import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { system, propTypes } from './lib/system'

const Longform = styled.div`
  > h2,
  > h3,
  > h4 {
    margin-top: ${themeGet('space.l')};
    position: relative;
    z-index: 0;

    @media screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin-top: ${themeGet('space.xl')};
    }

    @media screen and (min-width: ${themeGet('breakpoints.lg')}) {
      margin-top: ${themeGet('space.xxl')};
    }

    &:active,
    &:focus,
    &:hover {
      .headerLink {
        opacity: 1;
        visibility: visible;
      }
    }
  }

  > p,
  > ul,
  > ol {
    margin-bottom: ${themeGet('space.l')};
  }

  > blockquote,
  img,
  .gatsby-resp-image-wrapper,
  pre {
    margin-bottom: ${themeGet('space.xl')};
    margin-top: ${themeGet('space.xl')};
  }

  > p:first-child {
    font-size: ${themeGet('fontSizes.base')};

    @media screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: ${themeGet('fontSizes.l')};
    }

    @media screen and (min-width: ${themeGet('breakpoints.lg')}) {
      font-size: ${themeGet('fontSizes.h2')};
      line-height: 1.4;
      margin-bottom: ${themeGet('space.xl')};
      margin-left: -${themeGet('space.xxl')};
      margin-right: -${themeGet('space.xxl')};
    }
  }

  > ul,
  > ol {
    margin-left: calc(${themeGet('space.l')} + ${themeGet('space.xs')});

    > li:not(:last-child) {
      margin-bottom: ${themeGet('space.base')};
    }
  }

  img {
    margin-left: auto;
    margin-right: auto;
  }

  pre {
    font-size: ${themeGet('fontSizes.xs')};
    margin-left: -${themeGet('space.base')};
    margin-right: -${themeGet('space.base')};
    padding: ${themeGet('space.base')};

    > code {
      font-size: ${themeGet('fontSizes.xs')};
    }

    @media screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: ${themeGet('fontSizes.s')};
      margin-left: -${themeGet('space.xxl')};
      margin-right: -${themeGet('space.xxl')};
      padding: ${themeGet('space.xl')};
      padding-left: ${themeGet('space.xxl')};

      > code {
        font-size: ${themeGet('fontSizes.s')};
      }
    }

    @media screen and (min-width: ${themeGet('breakpoints.lg')}) {
      border-radius: ${themeGet('radii.base')};
    }
  }

  > blockquote {
    font-size: ${themeGet('fontSizes.base')};
    padding-left: ${themeGet('space.base')};
    padding-right: ${themeGet('space.base')};
    position: relative;

    &::before {
      color: ${themeGet('colors.light')};
      content: open-quote;
      display: block;
      font-family: ${themeGet('fonts.heading')};
      font-size: 7rem;
      left: calc(${themeGet('space.xl')} - ${themeGet('space.xl')});
      position: absolute;
      top: calc(-${themeGet('space.l')} - ${themeGet('space.base')});
      z-index: -1;
    }

    &::after {
      content: no-close-quote;
      visibility: hidden;
    }

    @media screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: ${themeGet('fontSizes.l')};
      padding-left: ${themeGet('space.xxl')};
      padding-right: ${themeGet('space.xxl')};

      &::before {
        left: calc(${themeGet('space.xxl')} - ${themeGet('space.l')});
        top: calc(-${themeGet('space.l')} - ${themeGet('space.base')});
      }
    }

    cite {
      color: ${themeGet('colors.medium')};
      display: block;
      font-size: ${themeGet('fontSizes.s')};
      margin-top: ${themeGet('space.s')};

      &::before {
        content: '— ';
      }
    }
  }

  .headerLink {
    left: -${themeGet('space.l')};
    opacity: 0;
    position: absolute;
    transition: 0.3s ease-in-out;
    visibility: hidden;
  }

  ${system}
`

Longform.propTypes = {
  ...propTypes,
}

export default Longform
